import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class channelsView_template extends vnTemplate {

    static CHANNEL_INFO_TAB = "info";
    static CHANNEL_VIDEOS_TAB = "videos";

    protected getTemplateHtml(): string {

        return /*html*/ `
        <div class="w-form w-form-large view-tag">
            <div class="form-header">
                <div class="w-btn">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                </div>
                <h3 class="form-title">Channel</h3>
                <button class="btn icon i-edit" type="button" data-bind="event: { click: onClickEdit }">
                    Edit Channel
                </button>
            </div>

            <div class="form-pagination">
                <button data-bind="event: { click: onClickSelectTab.bind($data, '${channelsView_template.CHANNEL_INFO_TAB}') }, css: { 'is-activated': selectedTab() == '${channelsView_template.CHANNEL_INFO_TAB}' }" class="btn icon i-channel" type="button"><span class="btn-text">Channel</span></button>
                <button data-bind="event: { click: onClickSelectTab.bind($data, '${channelsView_template.CHANNEL_VIDEOS_TAB}') }, css: { 'is-activated': selectedTab() == '${channelsView_template.CHANNEL_VIDEOS_TAB}' }" class="btn icon i-video-2" type="button"><span class="btn-text" data-bind="text: 'Videos' + (articles().length ? ' (' + articles().length + ')' : '')"></span></button>
            </div>

            <div class="ww-form-body" data-bind="css: { 'is-showing': selectedTab() == '${channelsView_template.CHANNEL_INFO_TAB}' }">
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Channel Information</strong>
                        <div class="form-group">
                            <dl class="double-list">
                                <dt>
                                    <span>Available for use</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: isAvailableForUse() ? 'Yes' : 'No'"></span>
                                </dd>

                                <dt class=>
                                    <span>Name</span>
                                </dt>
                                <dd class=>
                                    <span data-bind="text: name"></span>
                                </dd>

                                <dt class="full-width">
                                    <span>about</span>
                                </dt>
                                <dd class="full-width">
                                    <span data-bind="text: about"></span>
                                </dd>

                            </dl>

                            <strong class="form-sub-title">Creators</strong>
                            <dl class="double-list">
                                <dt data-bind="css: { 'full-width': creators().length }">
                                    <span>creators</span>
                                </dt>
                                <!-- ko foreach: creators -->
                                    <dd class="full-width">
                                        <span data-bind="text: valnet_user && valnet_user.fullName"></span>
                                    </dd>
                                <!-- /ko -->
                                <!-- ko ifnot: creators().length -->
                                    <dd><span>No Creators</span></dd>
                                <!-- /ko -->
                            </dl>

                            <strong class="form-sub-title">Social Media</strong>
                            <dl class="double-list">
                                <dt data-bind="css: { 'full-width': Object.keys(socialMediaLinks()).length }">
                                    <span>Social Media</span>
                                </dt>
                                <!-- ko foreach: Object.keys(socialMediaLinks()) -->
                                    <dd class="full-width no-cap"><a class="icon" target="_blank" data-bind="attr: { href: $parent.socialMediaLinks()[$data] }, text: $parent.socialMediaLinks()[$data], class: 'i-' + $data"></a></dd>
                                <!-- /ko -->
                                <!-- ko ifnot: Object.keys(socialMediaLinks()).length -->
                                    <dd><span>No Social Media</span></dd>
                                <!-- /ko -->
                            </dl>
                        </div>
                    </div>

                    <div class="form-body">
                        <strong class="form-sub-title">Picture</strong>
                        <div class="form-group">
                            <!-- ko if: picture() -->
                                <img data-bind="attr: { src: picture().url }"  alt="Picture" style="width: 50%;" />
                            <!-- /ko -->
                            <!-- ko if: !picture() -->
                                <span>No Picture</span>
                            <!-- /ko -->
                        </div>

                        <strong class="form-sub-title">Banner</strong>
                        <div class="form-group">
                            <!-- ko if: banner() -->
                                <img data-bind="attr: { src: banner().url }"  alt="Banner" style="width: 50%;" />
                            <!-- /ko -->
                            <!-- ko if: !banner() -->
                                <span>No Banner</span>
                            <!-- /ko -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="ww-form-body" data-bind="css: { 'is-showing': selectedTab() == '${channelsView_template.CHANNEL_VIDEOS_TAB}' }">
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Video Articles</strong>
                        <div class="form-group">
                            <dl class="">
                                <dt data-bind="css: { 'full-width': articles().length }">
                                    <span>Video Articles</span>
                                </dt>
                                <!-- ko foreach: articles -->
                                    <dd class="full-width articles-list">
                                        <a data-bind="click: $parent.onClickArticle.bind($data)" class="w-list">
                                            <span class="title" data-bind="text: $data.title"></span>
                                            <div>
                                                <span>ID: </span><span data-bind="text: $data.id"></span>
                                            </div>
                                            <div>
                                                <span>Last Published: </span><span data-bind="text: $data.dateMostRecentPublishedStatus ? $data.dateMostRecentPublishedStatus : 'Never Published'"></span>
                                            </div>
                                        </a>
                                    </dd>
                                <!-- /ko -->
                                <!-- ko ifnot: articles().length -->
                                    <dd><span>No Videos</span></dd>
                                <!-- /ko -->
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `;
    }

    protected initPartial(): void {
    }

    protected getTemplateName(): string {

        return "channelsView_template";
    }

    protected buildViewModel(): any {

        return {
            id: ko.observable(null),
            brand: ko.observable(""),
            name: ko.observable(""),
            about: ko.observable(""),
            isAvailableForUse: ko.observable(false),
            banner: ko.observable(null),
            picture: ko.observable(null),
            creators: ko.observable([]),
            socialMediaLinks: ko.observable({}),
            articles: ko.observableArray([]),

            selectedTab: ko.observable(channelsView_template.CHANNEL_INFO_TAB),

            onClickEdit: this.onClickEdit.bind(this),
            onClickCancel: this.onClickCancel.bind(this),
            onClickArticle: this.onClickArticle.bind(this),

            onClickSelectTab: this.onClickSelectTab.bind(this),
        }
    }

    public setBrand(brand): void {

      this.getTemplateViewModel().brand(brand);
    }

    public onClickEdit() {
        this.caller.edit(this.getTemplateViewModel().id());
    }
    public onClickCancel() {
        this.caller.cancel();
    }

    public setChannel(data): void {
        this.getTemplateViewModel().id(data.id);
        this.getTemplateViewModel().isAvailableForUse(data.isAvailableForUse);
        this.getTemplateViewModel().name(data.name);
        this.getTemplateViewModel().about(data.about);
        this.getTemplateViewModel().banner(data.banner);
        this.getTemplateViewModel().picture(data.picture);
        this.getTemplateViewModel().creators(data.creators);
        this.getTemplateViewModel().socialMediaLinks(data.socialMedia || {});

        let sortedArticles = [];
        if(data.articles) {
            sortedArticles = data.articles.sort((a, b) => {
                const dateA = new Date(a.dateMostRecentPublishedStatus.date).valueOf();
                const dateB = new Date(b.dateMostRecentPublishedStatus.date).valueOf();
                return dateB - dateA;
            });
        }

        this.getTemplateViewModel().articles(sortedArticles);
    }

    public onClickArticle(article) {
        this.caller.showArticle(article);
    }

    private onClickSelectTab(tab) {
        this.getTemplateViewModel().selectedTab(tab);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/channelsView_template.ts